import {
  ApolloLink,
  from,
  ApolloClient,
  InMemoryCache,
  HttpLink,
} from '@apollo/client'
import { onError as OnErrorLink } from '@apollo/client/link/error'

import { apiUrl } from 'config'
import { useMemo } from 'react'

const errorLink = OnErrorLink(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message, path }) =>
      // eslint-disable-next-line no-console
      console.log(`[GraphQL error]: Message: ${message}, Path: ${path}`)
    )
  }
  if (networkError) {
    // eslint-disable-next-line no-console
    console.log(`[Network error]: ${networkError}`)
  }
})

const links: ApolloLink[] = [
  new HttpLink({
    uri: `${apiUrl}/graphql`,
    credentials: 'same-origin',
    headers: {
      'x-apollo-client-name': `boarding`,
      'x-apollo-client-version': '',
    },
  }),
  errorLink,
]

export const useBuiltApolloClient = () => {
  return useMemo(() => {
    return new ApolloClient({
      link: from(links.reverse()),
      cache: new InMemoryCache(),
    })
  }, [])
}
